/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Unabletoretrieveoktaurldesc10Inputs */

const en_error_unabletoretrieveoktaurldesc10 = /** @type {(inputs: Error_Unabletoretrieveoktaurldesc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There might be an issue with the server. Please try again later.`)
};

/**
* | output |
* | --- |
* | "There might be an issue with the server. Please try again later." |
*
* @param {Error_Unabletoretrieveoktaurldesc10Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const error_unabletoretrieveoktaurldesc10 = /** @type {((inputs?: Error_Unabletoretrieveoktaurldesc10Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Unabletoretrieveoktaurldesc10Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_unabletoretrieveoktaurldesc10(inputs)
});
export { error_unabletoretrieveoktaurldesc10 as "error_unableToRetrieveOktaURLDESC" }